import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

const journeySteps = [
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
      </svg>
    ),
    title: "1. Identify a Problem",
    desc: "Communities identify real challenges that need solving.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
      </svg>
    ),
    title: "2. Propose a Project",
    desc: "A solution is proposed with a clear plan, budget and impact.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
      </svg>
    ),
    title: "3. Plan & Prepare",
    desc: "We verify the plan, suppliers, costs and milestones.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      </svg>
    ),
    title: "4. Community Contributes",
    desc: "People contribute from as little as R10. Together we reach the goal.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    title: "5. Goal Reached",
    desc: "Once the funding goal is reached, the project moves into execution.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: "6. Forge Vault Activates",
    desc: "Forge Vault verifies every requirement before any payment is released.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/>
      </svg>
    ),
    title: "7. Milestone Payments",
    desc: "Payments are released in stages as work is completed and verified.",
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: "8. Project Complete",
    desc: "The project is completed and the community enjoys the impact.",
  },
];

const contributionFlow = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/>
      </svg>
    ),
    title: "You contribute",
    desc: "Give from as little as R10.",
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      </svg>
    ),
    title: "It joins others",
    desc: "Your contribution joins thousands of others.",
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
    title: "We reach the goal",
    desc: "Together we hit the funding target.",
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: "Forge Vault protects it",
    desc: "Every rule is checked. Every rand is protected.",
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
    title: "Funds released in stages",
    desc: "Money is paid milestone by milestone to verified suppliers.",
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a9 9 0 019 9c0 4-2.5 7.5-6 9M12 2a9 9 0 00-9 9c0 4 2.5 7.5 6 9M12 2v18"/>
      </svg>
    ),
    title: "Real impact is created",
    desc: "Your contribution becomes real change in your community.",
  },
];

const vaultBlocks = [
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
      </svg>
    ),
    title: "Verify",
    desc: "We verify suppliers, documents and requirements.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
      </svg>
    ),
    title: "Check",
    desc: "Every milestone and evidence is checked.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/>
      </svg>
    ),
    title: "Approve",
    desc: "Community approval, where required.",
  },
  {
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 019.9-1"/>
      </svg>
    ),
    title: "Release",
    desc: "Payments released only when everything is in order.",
  },
];

const faqTeaser = [
  { q: "How much can I contribute?", a: "Any amount from R10 upward. There is no maximum, and every contributor has the same rights regardless of amount." },
  { q: "What happens if a project doesn't reach its goal?", a: "If a project fails to reach its funding goal within the campaign period, your contribution is returned to you in full." },
  { q: "Can I contribute to more than one project?", a: "Yes. You can contribute to as many projects as you like, and each is tracked separately in your dashboard." },
  { q: "Who chooses the projects?", a: "Communities propose projects. Every project goes through ID validation, a background review, and community voting before it goes live." },
  { q: "How do I know my money is safe?", a: "Your contribution sits in a dedicated project bank account, governed by Forge Vault, and is never held by Forge SA or any individual." },
  { q: "Can I propose a project?", a: "Yes. Log in to your dashboard and click Propose a Project to get started." },
];

export default function HowItWorks() {
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState(null);
  const toggleFaq = (i) => setOpenFaq(openFaq === i ? null : i);

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>

      <Navbar active="How It Works" />

      <style>{`
        .hiw3-hero { padding: 48px 32px; }
        .hiw3-hero-inner { max-width: 900px; margin: 0 auto; }
        .hiw3-hero-icon { display: none; width: 100%; max-width: 600px; height: 200px; margin: 32px auto 0; background: rgba(91,155,213,0.15); border-radius: 20px; align-items: center; justify-content: center; }
        .hiw3-section { max-width: 900px; margin: 0 auto; padding: 48px 32px 0; }
        .hiw3-steps-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px 16px; margin-top: 28px; }
        .hiw3-flow-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px 16px; margin-top: 28px; }
        .hiw3-vault-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-top: 24px; max-width: 620px; margin-left: auto; margin-right: auto; }
        .hiw3-ledger-empty { max-width: 520px; margin: 0 auto; background: #fff; border: 1px solid #EDE8DF; border-radius: 20px; padding: 40px 32px; text-align: center; }
        .hiw3-cta { padding: 64px 32px; margin-top: 56px; }
        @media (max-width: 768px) {
          .hiw3-hero { padding: 32px 20px; }
          .hiw3-hero-icon { display: flex; height: 140px; margin-top: 24px; }
          .hiw3-section { padding: 40px 20px 0; }
          .hiw3-steps-grid { grid-template-columns: 1fr 1fr; gap: 28px 14px; }
          .hiw3-flow-grid { grid-template-columns: 1fr 1fr; gap: 28px 14px; }
          .hiw3-vault-grid { grid-template-columns: 1fr 1fr; }
          .hiw3-ledger-empty { padding: 32px 20px; }
          .hiw3-cta { padding: 48px 20px; margin-top: 40px; }
          .hiw3-cta button { width: 100%; }
        }
      `}</style>

      {/* HERO */}
      <div className="hiw3-hero" style={{ background: "#F5F0E8" }}>
        <div className="hiw3-hero-inner">
          <h1 style={{ fontSize: "clamp(28px, 5vw, 46px)", fontWeight: 900, color: "#1A1A2E", letterSpacing: "-0.02em", margin: "0 0 12px" }}>
            How Forge SA Works
          </h1>
          <div style={{ fontSize: "clamp(18px, 3vw, 24px)", fontWeight: 800, color: "#C9A84C", marginBottom: 16 }}>
            Together, we build what matters.
          </div>
          <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.8, maxWidth: 560 }}>
            Forge SA is a community-powered platform that helps South Africans identify problems, fund solutions and build a better future, transparently.
          </p>
          <div className="hiw3-hero-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#1B3A6B" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
            </svg>
          </div>
        </div>
      </div>

      {/* SECTION 1: HOW FORGE SA WORKS */}
      <div className="hiw3-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
          01 &middot; How Forge SA Works
        </div>
        <div className="hiw3-steps-grid">
          {journeySteps.map((step, i) => (
            <div key={i} style={{ textAlign: "center" }}>
              <div style={{ width: 56, height: 56, background: "#1B3A6B", borderRadius: 16, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                {step.icon}
              </div>
              <div style={{ fontSize: 14, fontWeight: 800, color: "#1A1A2E", marginBottom: 6 }}>{step.title}</div>
              <div style={{ fontSize: 12, color: "#888", lineHeight: 1.6 }}>{step.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* SECTION 2: HOW YOUR CONTRIBUTION WORKS */}
      <div style={{ background: "#F5F0E8", marginTop: 56, padding: "48px 32px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto" }}>
          <div style={{ display: "inline-block", background: "rgba(46,125,50,0.08)", border: "1px solid rgba(46,125,50,0.2)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#2E7D32", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
            02 &middot; How Your Contribution Works
          </div>
          <div className="hiw3-flow-grid">
            {contributionFlow.map((step, i) => (
              <div key={i} style={{ textAlign: "center" }}>
                <div style={{ width: 56, height: 56, border: "1.5px solid #2E7D32", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 14px" }}>
                  {step.icon}
                </div>
                <div style={{ fontSize: 14, fontWeight: 800, color: "#1A1A2E", marginBottom: 6 }}>{step.title}</div>
                <div style={{ fontSize: 12, color: "#888", lineHeight: 1.6 }}>{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* SECTION 3: FORGE VAULT */}
      <div className="hiw3-section">
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
          03 &middot; Forge Vault, Protecting Every Rand
        </div>
        <p style={{ fontSize: 15, color: "#4A4A6A", lineHeight: 1.8, marginTop: 18, maxWidth: 560 }}>
          Forge Vault is our automated governance system that ensures transparency, accountability and trust.
        </p>
        <div className="hiw3-vault-grid">
          {vaultBlocks.map((block, i) => (
            <div key={i} style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 16, padding: 22 }}>
              <div style={{ marginBottom: 12 }}>{block.icon}</div>
              <div style={{ fontSize: 15, fontWeight: 800, color: "#1A1A2E", marginBottom: 6 }}>{block.title}</div>
              <div style={{ fontSize: 12, color: "#888", lineHeight: 1.6 }}>{block.desc}</div>
            </div>
          ))}
        </div>
        <div style={{ maxWidth: 620, margin: "16px auto 0", background: "rgba(46,125,50,0.06)", border: "1px solid rgba(46,125,50,0.2)", borderRadius: 16, padding: "18px 22px", display: "flex", gap: 12, alignItems: "flex-start" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2E7D32" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0, marginTop: 2 }}>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/>
          </svg>
          <div style={{ fontSize: 13, color: "#2E7D32", lineHeight: 1.7 }}>
            If any rule is not met, payments are paused until it is resolved.
          </div>
        </div>
      </div>

      {/* SECTION 4: PUBLIC LEDGER (empty state, honest) */}
      <div className="hiw3-section" style={{ paddingTop: 56 }}>
        <div style={{ display: "inline-block", background: "rgba(91,155,213,0.1)", border: "1px solid rgba(91,155,213,0.3)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#185FA5", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 24 }}>
          04 &middot; Public Ledger
        </div>
        <div className="hiw3-ledger-empty">
          <div style={{ width: 52, height: 52, background: "#F5F0E8", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/>
            </svg>
          </div>
          <h2 style={{ fontSize: 17, fontWeight: 900, color: "#1A1A2E", marginBottom: 8 }}>
            The ledger activates once contributions begin
          </h2>
          <p style={{ fontSize: 13, color: "#888", lineHeight: 1.7 }}>
            Every contribution, every milestone, and every payment will be recorded here, visible to anyone, without needing to log in. Recorded. Visible. Verifiable.
          </p>
        </div>
      </div>

      {/* SECTION 5: FAQ */}
      <div className="hiw3-section" style={{ paddingTop: 56, paddingBottom: 56 }}>
        <div style={{ display: "inline-block", background: "rgba(27,58,107,0.07)", border: "1px solid rgba(27,58,107,0.15)", borderRadius: 99, padding: "5px 16px", fontSize: 11, color: "#1B3A6B", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 24 }}>
          05 &middot; Frequently Asked Questions
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {faqTeaser.map((item, i) => (
            <div key={i} style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 14, overflow: "hidden" }}>
              <div onClick={() => toggleFaq(i)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", cursor: "pointer", gap: 10 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#1A1A2E" }}>{item.q}</div>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  style={{ transform: openFaq === i ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s", flexShrink: 0 }}>
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
              {openFaq === i && (
                <div style={{ padding: "0 20px 16px", fontSize: 12, color: "#4A4A6A", lineHeight: 1.65 }}>
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <span onClick={() => navigate("/faq")} style={{ fontSize: 13, color: "#1B3A6B", fontWeight: 700, cursor: "pointer" }}>
            See all questions &rarr;
          </span>
        </div>
      </div>

      {/* CTA */}
      <section className="hiw3-cta" style={{ background: "#1B3A6B", textAlign: "center" }}>
        <h2 style={{ fontSize: "clamp(24px, 4vw, 36px)", fontWeight: 900, color: "#fff", margin: "0 0 12px", letterSpacing: "-0.02em" }}>
          We don't just fund projects.<br /><span style={{ color: "#C9A84C" }}>We build South Africa.</span>
        </h2>
        <p style={{ color: "rgba(184,212,232,0.8)", fontSize: 14, marginBottom: 24 }}>
          Join the South Africans who are building the future, together.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => navigate("/projects")} style={{ background: "transparent", border: "1.5px solid rgba(184,212,232,0.4)", borderRadius: 99, padding: "13px 28px", color: "rgba(184,212,232,0.9)", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}>
            Explore Projects
          </button>
          <button onClick={() => navigate("/register")} style={{ background: "#C9A84C", border: "none", borderRadius: 99, padding: "13px 28px", color: "#fff", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}>
            Join the Movement
          </button>
        </div>
        <div style={{ marginTop: 28, fontSize: 12, color: "rgba(184,212,232,0.35)" }}>
          Forge SA. Built by us. For us.
        </div>
      </section>

    </div>
  );
}